import React from 'react';
import { BookOpen, Calendar, Layers, Target, FileText, PlayCircle } from 'lucide-react';
export function MockupShowcase() {
  return <section className="py-16 md:py-24 px-4 bg-surface/30 border-y border-zinc-800/50" data-id="element-255">
      <div className="max-w-6xl mx-auto" data-id="element-256">
        <div className="text-center mb-12 md:mb-16" data-id="element-257">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight" data-id="element-258">
            El ecosistema definitivo <br className="hidden md:block" data-id="element-259" />
            <span className="text-primary" data-id="element-260">para el profesional del HIIT</span>
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-261">
          {/* Mockup Image */}
          <div className="w-full lg:w-1/2 relative" data-id="element-262">
            <div className="absolute inset-0 bg-primary/20 blur-[100px] rounded-full pointer-events-none" data-id="element-263" />
            
          </div>

          {/* Features Grid */}
          <div className="w-full lg:w-1/2 grid grid-cols-2 gap-4 md:gap-6" data-id="element-264">
            <div className="bg-surface border border-zinc-800 rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:border-primary/50 transition-colors" data-id="element-265">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-266">
                <BookOpen className="w-6 h-6 text-primary" data-id="element-267" />
              </div>
              <span className="font-bold text-zinc-200" data-id="element-268">6 Tomos Premium</span>
            </div>
            <div className="bg-surface border border-zinc-800 rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:border-primary/50 transition-colors" data-id="element-269">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-270">
                <Layers className="w-6 h-6 text-primary" data-id="element-271" />
              </div>
              <span className="font-bold text-zinc-200" data-id="element-272">
                6 Bonos Exclusivos
              </span>
            </div>
            <div className="bg-surface border border-zinc-800 rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:border-primary/50 transition-colors" data-id="element-273">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-274">
                <Calendar className="w-6 h-6 text-primary" data-id="element-275" />
              </div>
              <span className="font-bold text-zinc-200" data-id="element-276">
                Calendarios 52 Semanas
              </span>
            </div>
            <div className="bg-surface border border-zinc-800 rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:border-primary/50 transition-colors" data-id="element-277">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-278">
                <Target className="w-6 h-6 text-primary" data-id="element-279" />
              </div>
              <span className="font-bold text-zinc-200" data-id="element-280">
                Protocolos Científicos
              </span>
            </div>
            <div className="bg-surface border border-zinc-800 rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:border-primary/50 transition-colors" data-id="element-281">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-282">
                <FileText className="w-6 h-6 text-primary" data-id="element-283" />
              </div>
              <span className="font-bold text-zinc-200" data-id="element-284">
                Planificaciones Listas
              </span>
            </div>
            <div className="bg-surface border border-zinc-800 rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:border-primary/50 transition-colors" data-id="element-285">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-286">
                <PlayCircle className="w-6 h-6 text-primary" data-id="element-287" />
              </div>
              <span className="font-bold text-zinc-200" data-id="element-288">
                300+ Clases Aplicables
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}